import React, { useState, useEffect } from "react"
import _ from "lodash"
import portfolioService from "data/portfolio"
// Styles
import { Label_s } from 'styles/app-styles'
import { MultipleRow_s } from 'components/table/hovers/hover-styles'

type IHover = {
  data: {
  }
  namedItems?: {
  }
  field?: string
}

const UserAccessHover = (props: IHover) => {
  const userGroups = _.get(props, "namedItems.userGroups");
  const [selectedGroups, setSelectedGroups] = useState<Array<number>>([]);

  useEffect(() => {
    portfolioService.fetch(_.get(props, "data.portfolioid"))
      .then((portfolio) => {
        setSelectedGroups(_.chain(portfolio).get('usergroups').map('usergroupid').uniq().value())
      })
  }, [props.data])

  if(selectedGroups.length === 1) {
    let code = _.get(_.find(userGroups, (g) => g.usergroupid === selectedGroups[0]), "code")
    return <span>{`User Group: ${code}`}</span>
  } else return (
    <div>
      <MultipleRow_s>
        <table>
          <thead>
            <th>
              <Label_s>User Groups</Label_s>
            </th>
          </thead>
          { _.chain(selectedGroups).take(3).map((group) => {
            let ug = _.find(userGroups, (g) => g.usergroupid === group)
            let code = _.get(ug, "code")
            let name = _.get(ug, "name")
            return (
              <tr>
                <span>{`${code} - ${name}`}</span>
              </tr>
            )
          }).value() }
        </table>
        { (selectedGroups.length > 3) && <div style={{marginLeft: 'auto', textAlign: 'right'}}><strong>...</strong></div>}
      </MultipleRow_s>
    </div>
  )
}

export default UserAccessHover
